import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './EditorBookPageNumbers.css';

class EditorBookPageNumbers extends Component {
  constructor(...args) {
    super(...args);
    const { lang } = this.props;
    this.texts = {
      page: lang.page_number,
    };
  }


  pages(pageNumber, page, properties) {
    return this.pageNumbers(pageNumber, properties);
  }

  pageNumbers = (number, properties) => {
    let pageText = this.props.lang.cover;
    const { calendarStartYear, calendarStartMonth } = properties;


    const year = calendarStartYear;
    const month = number.order === 1 ? parseInt(calendarStartMonth, 10) - 1 : (parseInt(calendarStartMonth, 10) - 2) + (number.order);
    const event = new Date(year, month);
    const options = {
      month: 'long',
    };
    const getLocale = event.toLocaleDateString('hu-hu', options);
    if (number.order !== 0) {
      pageText = getLocale;
    }

    return (
      <div className="pages">
        <p>{pageText}</p>
      </div>
    );
  }

  renderPages(page, pageNumber, style, properties) {
    return (
      <div className="page-numbers" style={style}>
        {this.pages(page, pageNumber, properties) }
      </div>
    );
  }

  render() {
    const {
      style,
      page,
      pageNumber,
      bookProperties,
    } = this.props;
    return this.renderPages(page, pageNumber, style, bookProperties);
  }
}

EditorBookPageNumbers.defaultProps = {
  page: {},
  pageNumber: 0,
  style: {
    width: '1320px',
  },
  lang: {},
  bookProperties: {},
};

EditorBookPageNumbers.propTypes = {
  pageNumber: PropTypes.number,
  style: PropTypes.object,
  page: PropTypes.object,
  lang: PropTypes.object,
  bookProperties: PropTypes.object,
};

export default EditorBookPageNumbers;



// WEBPACK FOOTER //
// ./src/components/editor-book-page-numbers/EditorBookPageNumbers.jsx